// extracted by mini-css-extract-plugin
module.exports = {"lawyer_cases_box":"cases_lawyer_cases_box__28vpk","lawyer_cases_name":"cases_lawyer_cases_name__2mQHk","lawyer_cases_description":"cases_lawyer_cases_description__3bKUA"};